import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import dayjs from 'dayjs'
import RelativeTime from 'dayjs/plugin/relativeTime'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import Card from '../../../../components/Card'
import EventAvatar from '../../../../components/EventAvatar'
import UpcomingEvent from '../../../../components/UpcomingEvent'
import EventParticipationSummary from '../../../../components/EventParticipationSummary'
import { usePageInfo } from '../../../../config/queries'

dayjs.extend(RelativeTime)

const EventCard = ({ event }: { event: wowaudit.EventReference }) => {
  const {
    data: { user },
  } = usePageInfo()

  const team = user?.teamReferences.find(
    (teamReference) => teamReference.id === event.teamId,
  )

  return (
    <Link to={event.path} className='group block'>
      <Card className='flex w-full p-2 transition-colors group-hover:border-primary/40 sm:hidden'>
        <UpcomingEvent eventReference={event} />
      </Card>

      <Tooltip delayDuration={150}>
        <TooltipTrigger asChild>
          <Card className='hidden w-full items-center gap-2 px-2 py-2.5 transition-colors group-hover:border-primary/40 sm:flex'>
            <EventAvatar eventReference={event} className='h-9 w-9 shrink-0' />
            <div className='flex min-w-0 flex-col'>
              <span className='truncate text-sm font-medium capitalize'>
                {event.title}
              </span>
              <span className='truncate text-xs text-muted-foreground'>
                {event.primaryDifficulty ? (
                  <span className='capitalize'>
                    {event.primaryDifficulty.replace('_', ' ')},{' '}
                  </span>
                ) : null}
                {dayjs(event.startsAt).fromNow()}
              </span>
            </div>
            <ArrowRight className='ml-auto h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-primary' />
          </Card>
        </TooltipTrigger>
        <TooltipContent
          side='top'
          className='flex flex-col items-center gap-2 p-3'
        >
          {team ? (
            <span>
              {team.ownerReference.name} &middot; {team.name}
            </span>
          ) : null}
          <div className='flex items-center justify-between gap-4'>
            <EventParticipationSummary eventReference={event} />
          </div>
        </TooltipContent>
      </Tooltip>
    </Link>
  )
}

export default EventCard
